// client/src/services/categoryService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const getCategories = async () => {
  const response = await fetch(`${apiUrl}/categories`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des catégories.');
  return await response.json();
};

const createCategory = async (data) => {
  const response = await fetch(`${apiUrl}/categories`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok)
    throw new Error(result.message || 'Erreur lors de la création de la catégorie.');
  return result;
};

const updateCategory = async (id, data) => {
  const response = await fetch(`${apiUrl}/categories/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors de la mise à jour.');
  return result;
};

const deleteCategory = async (id) => {
  const response = await fetch(`${apiUrl}/categories/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.message || 'Erreur lors de la suppression.');
  }
  return true;
};

const categorize = async (accountId) => {
  const response = await fetch(`${apiUrl}/categories/categorize`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(accountId ? { accountId } : {})
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors de la catégorisation.');
  return result;
};

const setTransactionCategory = async (transactionId, categoryId, applyToSimilar = false) => {
  const response = await fetch(`${apiUrl}/categories/transactions/${transactionId}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ categoryId, applyToSimilar })
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors du reclassement.');
  return result;
};

const categoryService = {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  categorize,
  setTransactionCategory
};

export default categoryService;
